import { Button, Input } from "@ttc3k/trekker";
import { Link as LinkIcon } from "iconoir-react/regular";
import { ComponentProps } from "react";
import {
  RegisterOptions,
  useController,
  useFormContext,
} from "react-hook-form";
import { isValidUrl } from "shared/utils/urlValidators";

export type ControlledInputProps = ComponentProps<typeof Input> & {
  name: string;
  registerOptions?: RegisterOptions;
  normalizer?: (value: string) => string;
};

export const ControlledInput = ({
  name,
  hint,
  registerOptions,
  normalizer,
  ...rest
}: ControlledInputProps) => {
  const { control, setValue } = useFormContext();
  const { fieldState, field } = useController({ name, control, rules: registerOptions });

  const runNormalizer = () => {
    let value = field.value;
    if (!value) return;

    value = normalizer?.(value) ?? value;
    setValue(name, value, { shouldDirty: true, shouldValidate: true });
  };

  const props = {
    ...rest,
    bg: "white",
    ...field,
    hint: fieldState.error?.message ?? hint,
    ...(fieldState.error ? { "data-invalid": true, "aria-invalid": true } : {}),
  };

  return rest.type === "url" ? (
    <div style={{ ...rest.style, position: "relative" }}>
      <Input
        {...props}
        {...(rest.type === "url" && { style: { paddingRight: "40px" } })}
        onBlurCapture={() => normalizer && runNormalizer()}
      />
      {field.value && !fieldState.invalid && isValidUrl(field.value) && (
        <Button
          visual="unstyled"
          color="icon.light"
          Icon={LinkIcon}
          style={{
            position: "absolute",
            right: "0",
            top: "26px",
            outlineColor: "var(--wa-colors-ink-300)",
            outlineOffset: "-2px",
          }}
          onClick={() => window.open(field.value, "_blank")}
          type="button"
        />
      )}
    </div>
  ) : (
    <Input {...props} />
  );
};
